module.exports = __webpack_public_path__ + "media/images/recruitment/landing/mv_price_sp-9c8dbd7c4109978cb887638911ffa8b5.png";